














































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import Loading from '@/components/Loading.vue';
import Error from '@/components/Error.vue';
import Success from '@/components/Success.vue';
import SectionHeader from '@/components/SectionHeader.vue';
import { Enterprise } from '@/types';
import { ApiClient, curApiClient } from '@/services/ApiClient';
import { ApiService, curApiService } from '@/services/ApiService';


@Component({
  components: {
    Loading,
    Error,
    SectionHeader,
    Success
  },
})
export default class EditEnterprise extends Vue {

  @Prop({ default: {},  type: Object}) enterprise!: Enterprise;
  @Prop({ default: () => [],  type: Array}) existingEntIdList!: string[];
  @Prop({ default: () => [],  type: Array}) enrolProfileIdList!: string[];

  @Watch("enterprise", {immediate:true})
  onEnterprise(newValue:Enterprise, oldValue:Enterprise){

    console.log(`Updating enterprise to ${newValue.enterpriseId}`);

    // we update our model with the start up data
    this.dataDecoding = newValue.dataDecoding;
    this.dataStorage = newValue.dataStorage;

    this.subscriberId = newValue.nwServer && newValue.nwServer.actility && newValue.nwServer.actility.subscriberId ? newValue.nwServer.actility.subscriberId : 0;
    this.supplierId = newValue.nwServer && newValue.nwServer.actility && newValue.nwServer.actility.supplierId ? newValue.nwServer.actility.supplierId : '';
    this.enrolId = newValue.nwServer && newValue.nwServer.actility && newValue.nwServer.actility.enrolId ? newValue.nwServer.actility.enrolId : '';
  }

  // our model
  error:string = '';
  success:string = '';
  
  dataStorage:boolean = true;
  dataDecoding:boolean = true;

  subscriberId:number = 0;
  supplierId:string = '';
  enrolId:string = '';

  httpBusy:boolean = false;

  // internal dependencies
  private apiClient:ApiClient = curApiClient;
  private apiService:ApiService = curApiService;
  
  async mounted() {

  }

  get canUpdate():boolean {
    return !this.httpBusy;
  }

  async updateDataStorage() {

    this.httpBusy = true;

    this.error = '';
    
    const reply = await this.apiClient.updateEnterpriseDataStorage({
      enterpriseId: this.enterprise.enterpriseId,
      dataStorage: this.dataStorage,
      dataDecoding: this.dataDecoding
    });

    this.httpBusy = false;
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `unable to update data storage options: ${reply.errorMsg}`;

    this.setSuccess(`data storage for enterprise ${this.enterprise.enterpriseId} updated successfully`);
  }

  async updateNwServer() {

    this.httpBusy = true;

    this.error = '';
    
    const reply = await this.apiClient.updateEnterpriseNwServer({
      enterpriseId: this.enterprise.enterpriseId,
      subscriberId: this.subscriberId,
      enrolId: this.enrolId !== '' ? this.enrolId : undefined,
      supplierId: this.supplierId !== '' ? this.supplierId : undefined,
    });

    this.httpBusy = false;
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `unable to update network server options: ${reply.errorMsg}`;

    this.setSuccess(`network server options for enterprise ${this.enterprise.enterpriseId} updated successfully`);
  }

  setSuccess(str:string) {
    this.success = str;
    setTimeout(() => this.$emit('cancel'), 1000);
  }

  cancel() {
    this.$emit('cancel');
  }
}
